import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as classNames from 'classnames';
import { get } from 'lodash';

import FormGroupWithSelect from '@reverbdotcom/commons/dist/components/form_group_with_select';
import { APIRequest } from '@reverbdotcom/discovery-ui';
import { trackEvent } from '@reverbdotcom/commons/dist/elog/mparticle_tracker';
import { MParticleEventName } from '@reverbdotcom/commons/dist/elog/mparticle_types';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/dist/elog/mparticle';
import { experiments } from '@reverbdotcom/commons/dist/constants';

import UrlHelpers from '../shared/url_helpers';
import { frontendCurrentUser } from '../parse_meta';

const ELECTRIC_GUITAR_CATEGORY_UUID = 'dfd39027-d134-4353-b9e4-57dc6be791b9';
const INTERFACES_CATEGORY_UUID = 'dfb72735-b7a3-4c8f-9b14-0d1dd904af1e';
const MICROPHONES_CATEGORY_UUID = '0f2bbf76-3225-44d5-8a5b-c540cc1fd058';

const TRAIT_SELECT = 'TraitSelect';

const user = get(frontendCurrentUser(), 'user', {});

class TraitSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      traits: [],
      loading: false,
      expanded: false,
    };

    this.renderSelect = this.renderSelect.bind(this);
  }

  isOnSpecifiedCategory() {
    const { categories } = this.props;

    if (!categories.length) { return null; }

    return categories.some(category => {
      return (category.parent && category.parent.attributes.uuid === ELECTRIC_GUITAR_CATEGORY_UUID) ||
        category.attributes.uuid === ELECTRIC_GUITAR_CATEGORY_UUID ||
        category.attributes.uuid === MICROPHONES_CATEGORY_UUID ||
        category.attributes.uuid === INTERFACES_CATEGORY_UUID;
    });
  }

  getCategoryUuid() {
    return this.props.categories[0].attributes.uuid;
  }

  fetchTraits() {
    this.setState({ loading: true });

    APIRequest.V3.get(
      UrlHelpers.categoriesWithTraitsPath,
      { category_uuids: this.getCategoryUuid() },
    ).then(data => {
      this.setState({
        traits: data.traits,
        loading: false,
      });
    });
  }

  getFormType() {
    if (this.props.blankForm) {
      return 'Blank Form';
    }

    if (this.props.persistedForm) {
      return 'Persisted Form';
    }

    return 'Seeded Form';
  }

  componentDidMount() {
    trackEvent({
      eventName: MParticleEventName.ComponentView,
      componentName: TRAIT_SELECT,
      displayStyle: this.getFormType(),
      experiments: formatExperimentsForEventAttributes(user, [experiments.SELL_FORM_TRAITS]),
    });

    if (this.props.blankForm && this.isOnSpecifiedCategory()) {
      this.fetchTraits();
    }

    this.setState({ traits: this.props.traits });
  }

  componentDidUpdate(prevProps) {
    if (this.props.categories !== prevProps.categories) {
      this.fetchTraits();
    }
  }

  getOptions(trait) {
    if (trait.disabled) {
      return trait.values.map(value => (
        {
          value: value.uuid,
          text: value.name,
          disabled: true,
        }
      ));
    }

    return [{
      value: '',
      text: I18n.t('listingForm.traitSelect.optionPlaceholder'),
    }].concat(trait.values.map(value => (
      {
        value: value.uuid,
        text: value.name,
      }
    )));
  }

  handleChange(newValue, idx) {
    this.setState(prevState => {
      const traits = [...prevState.traits];
      traits[idx] = { ...traits[idx], selected: newValue };
      return { traits };
    });
  }

  renderExpandButton() {
    const { expanded } = this.state;

    return (
      <div className="trait-select__expand">
        <button
          type="button"
          className="button button--small"
          onClick={() => this.setState({ expanded: !expanded })}
        >
          {I18n.t(`listingForm.traitSelect.toggle.${expanded ? 'hide' : 'show'}`)}
        </button>
      </div>
    );
  }

  renderSelect(trait, idx) {
    const value = trait.values.find(val => val.name === trait.selected);

    return (
      <div className="trait-select__field" key={trait.uuid}>
        <input type="hidden" name="product[traits][][uuid]" value={trait.uuid} />
        <FormGroupWithSelect
          label={trait.name}
          inputName="product[traits][][trait_value]"
          fieldName="newValue"
          updateField={val => this.handleChange(val.newValue, idx)}
          id={trait.uuid}
          disabled={trait.disabled}
          options={this.getOptions(trait)}
          value={value && value.uuid}
        />
      </div>
    );
  }

  render() {
    if (!this.state.traits.length || this.state.loading) { return null; }
    const classes = classNames(
      'trait-select',
      { 'trait-select--expanded': this.state.expanded },
    );

    return (
      <div className={classes}>
        <div className="alert-box alert-box--gray alert-box--small mtb-1">
          <b className="d-block">
            {I18n.t('listingForm.traitSelect.addTechSpecs')}
          </b>
          {I18n.t('listingForm.traitSelect.traitSelectDescription')}
        </div>
        <div className="trait-select__fields">
          {this.state.traits.map(this.renderSelect)}
        </div>
        {this.renderExpandButton()}
      </div>
    );
  }
}

TraitSelect.propTypes = {
  traits: PropTypes.arrayOf(PropTypes.shape({})),
  categories: PropTypes.arrayOf(PropTypes.shape({})),
  blankForm: PropTypes.bool,
  persistedForm: PropTypes.bool,
};

export default TraitSelect;



// WEBPACK FOOTER //
// ./javascripts/components/listing_form/trait_select.jsx